import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../../auth/auth.service';
import { User } from '../../auth/user';
import { routes } from '../../routes/routes';

@Component({
  selector: 'welcome-brand-page',
  templateUrl: './welcome-brand-page.component.html',
  styleUrl: './welcome-brand-page.component.scss',
})
export class WelcomeBrandPageComponent implements OnInit {
  currentUser$: Observable<User | null>;

  protected readonly routes = routes;

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {
    this.currentUser$ = authService.currentUser$;
  }

  ngOnInit() {
    this.addTracking();

    setTimeout(async () => {
      await this.refreshUser();
    }, 3000);
  }

  addTracking() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      gtag('event', 'conversion', {'send_to': 'AW-16614095886/60hrCL_zvcYZEI74m_I9'});
      fbq('trackCustom', 'Lead Brand');
    `;
    document.body.appendChild(script);
  }

  async refreshUser() {
    await this.authService.refreshCurrentUser();
    this.router.navigate(['/'], { queryParamsHandling: 'merge' });
  }
}
